// ai-sidebar/ai-assistant-collapsed.tsx
// State 3: collapsed. Per the design (Direction D, frameCollapsed), this is NOT
// a full-height rail — it's a floating launcher anchored to the bottom-right:
// an "Ask about this page" hint pill stacked above the "Ask Upmode / ⌘K" pill.
// The page behind stays fully interactive; only the pills capture clicks.
import { Orb } from "./components/orb";
import { useAssistant } from "./use-assistant";

export function AiAssistantCollapsed({ embedded = false }: { embedded?: boolean }) {
  const { status, setCollapsed } = useAssistant();
  const working = status === "thinking" || status === "streaming";
  const expand = () => setCollapsed(false);

  return (
    <div className={`ai-sidebar ${embedded ? "absolute" : "fixed"} inset-0 z-50 pointer-events-none`}>
      {/* Hint pill — right:20px, bottom:88px */}
      <button
        type="button"
        onClick={expand}
        className="pointer-events-auto absolute flex items-center"
        style={{
          right: 20,
          bottom: 88,
          gap: 8,
          background: "var(--card)",
          border: "1px solid var(--border)",
          borderRadius: 999,
          padding: "7px 13px 7px 12px",
          boxShadow: "var(--elevation-md)",
        }}
      >
        <span style={{ fontSize: 12, fontWeight: 500, color: "var(--muted-foreground)" }}>
          Ask about this page
        </span>
      </button>

      {/* Launcher pill — right:20px, bottom:20px */}
      <button
        type="button"
        onClick={expand}
        aria-label="Ask Upmode"
        className="pointer-events-auto absolute flex items-center"
        style={{
          right: 20,
          bottom: 20,
          gap: 11,
          background: "var(--card)",
          border: "1px solid var(--border)",
          borderRadius: 999,
          padding: "9px 16px 9px 9px",
          boxShadow: "var(--elevation-lg)",
        }}
      >
        <Orb size={38} working={working} />
        <span style={{ fontSize: 13.5, fontWeight: 600, color: "var(--foreground)" }}>
          Ask Upmode
        </span>
        <span
          style={{
            fontFamily: "var(--font-mono)",
            fontSize: 10.5,
            color: "var(--spectral-violet)",
            background: "var(--spectral-violet-10)",
            borderRadius: 6,
            padding: "3px 7px",
          }}
        >
          ⌘K
        </span>
      </button>
    </div>
  );
}
